import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=197a7bd8&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=197a7bd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197a7bd8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('197a7bd8')) {
      api.createRecord('197a7bd8', component.options)
    } else {
      api.reload('197a7bd8', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=197a7bd8&scoped=true&", function () {
      api.rerender('197a7bd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25xx73rc6ZHze/JS/comp/DateRangeExt.vue"
export default component.exports